import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { BaseFiltersOptions, FiltersActionType, FiltersStore } from './FiltersReducer.types';

export const FILTERS_WITH_ROUTER = { learn: 'learn', dataExplorer: 'dataExplorer' };

const convertFiltersToOptions = (data: any, type: string) => {
  if (data[type] && data[type].choices && Array.isArray(data[type].choices)) {
    let typeOptions: BaseFiltersOptions[] = [];
    data[type].choices.forEach((typeOption: { value: string; label: string }, index: number) => {
      if (typeOption.value !== null) {
        typeOptions = typeOptions.concat([
          {
            key: `events-filter-${type}-${index}`,
            text: typeOption.label,
            value: typeOption.value,
          },
        ]);
      }
    });

    return typeOptions;
  } else {
    return [];
  }
};

// @ts-ignore
export const initialState: FiltersStore = Immutable.fromJS({
  type: '',
  language: '',
  country: '',
  city: '',
  typeOptions: [],
  languageOptions: [],
  countryOptions: [],
  cityOptions: [],
  filterOpen: false,
  isFetching: false,
});

const FiltersReducer = handleActions<any>(
  {
    CHANGE_FILTER_OPEN: (state: FiltersStore, action: FiltersActionType) => state.set('filterOpen', action.payload),

    CHANGE_FILTER: (state: FiltersStore, action: FiltersActionType) => state.merge(Immutable.fromJS(action.payload)),

    RESPONSE_EVENTS_OPTIONS: (state: FiltersStore, actions: FiltersActionType) => {
      if (actions.payload.data) {
        const categories = {
          type: {
            type: 'choice',
            choices: [
              { value: 'ONLINE', label: 'Online' },
              { value: 'OFFLINE', label: 'At Venue' },
            ],
          },
        };

        return state
          .set('typeOptions', Immutable.fromJS(convertFiltersToOptions(categories, 'type')))
          .set('cityOptions', Immutable.fromJS(convertFiltersToOptions(actions.payload.data, 'city')))
          .set('countryOptions', Immutable.fromJS(convertFiltersToOptions(actions.payload.data, 'country')))
          .set('languageOptions', Immutable.fromJS(convertFiltersToOptions(actions.payload.data, 'language')));
      } else {
        return state;
      }
    },

    AUTHENTICATION_LOGOUT: () => initialState,

    RESET_ALL_FILTERS: (state: FiltersStore) =>
      state.merge(
        Immutable.fromJS({
          type: '',
          language: '',
          country: '',
          city: '',
        })
      ),
  },
  initialState
);

export default FiltersReducer;
